module.exports = __webpack_public_path__ + "img/weapon-1hand.86224bcb.png";